import React, { useState } from 'react'
import { Experience } from '../../../../../Types/Resume'
import { Grid, Typography, Collapse, Link, Divider, IconButton, Tooltip } from '@mui/material'
import { removeUnwantedCharacters } from '../../../../../Utils/String'
import moment from 'moment'
import { ExperienceType } from '../../../../../Schemas/ResumeSchemas'
import { ModifyExperienceModal } from '../Edit/Experience/ModifyExperienceModal'
import { Edit, Delete } from '@mui/icons-material'

interface IProps extends ExperienceType {
    index: number
    readOnly?: boolean;
    handleEdit?: (edu: ExperienceType, idx: number) => void;
    handleDelete?: (idx: number) => void;
}   

export const ViewExperience = ({ description, title, start_date, end_date, company, index, present, readOnly, handleEdit, handleDelete}: IProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    const [open, setOpen] = useState(false);
    const [deleteClicks, setDeleteClicks] = useState(1);
    const [showMore, setShowMore] = useState(false);
    /* ******************** Functions ******************** */
    const formatDate = (start: string, end: string | undefined) => {
        const startDate = moment(start)
        const endDate = end ? moment(end) : moment().utc()
        return `${endDate.diff( startDate, 'years')} years · ${startDate.format("MMM YYYY")} - ${!present ? endDate.format("MMM YYYY") : 'Present'}`
    }
    const editClicked = () => {
        setOpen(true);
    }
    const deleteClicked = () => {
        if (deleteClicks === 2) {
            handleDelete!(index);
        } else {
            setDeleteClicks(2);
            setTimeout(() => {
                setDeleteClicks(0);
            }, 7000)
        }
    }
    const handleChange = (data: ExperienceType) => {
        handleEdit!(data, index);
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Grid display={"flex"} flexDirection={"column"} marginBottom={1}>
                
                <Grid display={'flex'} flexDirection={'row'}>
                    <Grid display={'flex'} flexDirection={'column'} flex={1}>
                        <Typography variant='body-medium' fontWeight={'bold'}>{company ?? "N/A"}</Typography>
                        <Typography color={'black.200'} variant='body-medium'>
                            {formatDate(start_date, end_date)}
                        </Typography>
                    </Grid>
                    {
                        !readOnly && 
                        <Grid display={"flex"} flexDirection={"row"} flex={1} justifyContent={'flex-end'}>
                            <IconButton size="medium" color="primary" onClick={editClicked}>
                                <Edit fontSize="small"/>
                            </IconButton>
                            <Tooltip open={deleteClicks == 2} title='Click again to confirm delete' placement="right" arrow>
                                <IconButton size="medium" color={deleteClicks == 2 ? "error" : "primary"} onClick={deleteClicked}>
                                    <Delete fontSize="small"/>
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    }
                </Grid>
                <Collapse in={showMore} collapsedSize={45}>
                    <Typography variant='body-medium' color={'black.400'} whiteSpace={'pre-wrap'}>{removeUnwantedCharacters(description ?? '')}</Typography>
                </Collapse> 
                <Link  component={'button'} sx={{width: 'fit-content', marginTop: 1}} underline={'none'} onClick={() => setShowMore(!showMore)}>
                    <Typography fontWeight={"bold"} variant='label-large' sx={{textOverflow: 'ellipsis'}}>
                        { showMore ? 'See less' : 'See more' }
                    </Typography>
                </Link>
            </Grid>
            <Divider sx={{ marginBottom: 1}}/>
            <ModifyExperienceModal 
                {...{
                    open,
                    setOpen,
                    handleChange,
                    defaultValues: {
                        company,
                        present,
                        end_date,
                        start_date,
                        description,
                        title
                    },
                    type: 'Edit'
                }}
            />
        </>
    )
}